import { render, staticRenderFns } from "./video-dialog.vue?vue&type=template&id=7bad7e1d"
import script from "./video-dialog.vue?vue&type=script&lang=js"
export * from "./video-dialog.vue?vue&type=script&lang=js"
import style0 from "./video-dialog.vue?vue&type=style&index=0&id=7bad7e1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports